// extracted by mini-css-extract-plugin
export default {"wrapper":"KeyValueLabel_wrapper__p0pBN","key":"KeyValueLabel_key__1oR6f","value":"KeyValueLabel_value__TWeu+"};